import { 
    apiRequest,
    cutiCancel,
    cutiSubmitCancel
} from '../../../../../../services/adapters/kepegawaian/cutiService'

class DetailRepository {

    fetchCancel = async (query) => {
        return await apiRequest("post", cutiCancel, {
            body: query
        }, true)
    }

    fetchSubmitCancel = async (query) => {
        return await apiRequest("post", cutiSubmitCancel, {
            body: query
        }, true)
    }

}

export default DetailRepository